export const contactUs = {
  contactInformation: '聯絡',
  projectBackground: '簡介',
}
